import { ReactNode } from 'react';
import { useIsAuthenticated } from '@data';
import { AppLoader } from '@components';
import { AuthMethod } from './authMethod';
import { useAuthentication } from './useAuthentication';
import { LoginScreen } from './LoginScreen';

type AuthGateProps = {
  children: ReactNode;
};

export const AuthGate = ({ children }: AuthGateProps) => {
  const isAuthenticated = useIsAuthenticated();
  const { method, login } = useAuthentication();

  if (isAuthenticated) {
    return <>{children}</>;
  }

  // While silent NAA is running, show the app loader instead of the login screen.
  if (method === AuthMethod.NAA_SILENT) {
    return <AppLoader />;
  }

  // The login button (legacy Dialog API) is only enabled once it's the only method left,
  // so it can't be started while interactive NAA or SSO is still running.
  const isLoginDisabled = method !== AuthMethod.DIALOG;

  return <LoginScreen onLogin={login} isLoginDisabled={isLoginDisabled} />;
};
